module.exports = __webpack_public_path__ + "img/story-mode.22114db0.svg";